import { Paper, Typography } from '@mui/material'
import React from 'react'
import styles from '../../styles/pages/user/managerdashboard/manager-dashborad-assignaccount.module.scss'

export default function ManagerSummaryCard({ videoTitle, children }) {
    return (
        <>
            <Paper className={`${styles.videoSummaryCard}`}>
                <Typography variant='h4'>{videoTitle}</Typography>
                {children}
            </Paper>
        </>
    )
}
